export const LANGUAGES = [
  { code: 'en-GB', name: 'english_uk' },
  { code: 'en-US', name: 'english_us' },
  { code: 'ar', name: 'arabic' },
  { code: 'bg', name: 'bulgarian' },
  { code: 'cs', name: 'czech' },
  { code: 'de', name: 'german' },
  { code: 'el', name: 'greek' },
  { code: 'es', name: 'spanish' },
  { code: 'fr', name: 'french' },
  { code: 'he', name: 'hebrew' },
  { code: 'hi', name: 'hindi' },
  { code: 'id', name: 'indonesian' },
  { code: 'it', name: 'italian' },
  { code: 'ja', name: 'japanese' },
  { code: 'ko', name: 'korean' },
  { code: 'ms', name: 'malay' },
  { code: 'nl', name: 'dutch' },
  { code: 'pl', name: 'polish' },
  { code: 'pt', name: 'portuguese_portugal' },
  { code: 'pt-BR', name: 'portuguese_brazil' },
  { code: 'ro', name: 'romanian' },
  { code: 'ru', name: 'russian' },
  { code: 'th', name: 'thai' },
  { code: 'tr', name: 'turkish' },
  { code: 'uk', name: 'ukrainian' },
  { code: 'vi', name: 'vietnamese' },
  { code: 'zh-CN', name: 'chinese_simplified' },
  { code: 'zh-TW', name: 'chinese_traditional' },
  { code: 'fa', name: 'persian' },
]

export const LANGUAGES_SUGGEST = [
  { code: 'en-GB', name: 'english_uk' },
  { code: 'en-US', name: 'english_us' },
  { code: 'fr', name: 'french' },
  { code: 'de', name: 'german' },
  { code: 'it', name: 'italian' },
  { code: 'pt-BR', name: 'portuguese_brazil' },
  { code: 'es', name: 'spanish' },
  { code: 'vi', name: 'vietnamese' },
]

export const SUPPORTED_LNGS = LANGUAGES.map((l) => l.code)
